import { FC } from "react";
import { Navigate } from "react-router-dom";
import environment from "../../environment/environment";

const RequireNotPublic: FC<{ children: React.ReactElement }> = ({ children }) => {
  if (environment.publicMode) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RequireNotPublic;
